module.exports = __webpack_public_path__ + "static/media/uploadInactive.2617f512.svg";